import { useEffect, useState } from "react";
import { ScanFace, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { CameraCapture } from "../../components/CameraCapture";
import { usePortalAuth } from "../../context/PortalAuthContext";
import { portalApi } from "../../lib/portalApi";
import { errMsg } from "../../lib/api";
import { detectFaces, loadFace } from "../../lib/face";

export default function FaceRegister() {
  const { refresh } = usePortalAuth();
  const [modelReady, setModelReady] = useState(false);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    loadFace().then(() => setModelReady(true)).catch(() => setMsg("Gagal memuat pengenal wajah. Periksa koneksi lalu muat ulang."));
  }, []);

  const onCapture = async (canvas) => {
    setBusy(true);
    setMsg("");
    try {
      const faces = await detectFaces(canvas);
      if (faces.length === 0) throw new Error("Wajah tidak terdeteksi. Pastikan wajah terlihat jelas dan cahaya cukup, lalu ulangi.");
      if (faces.length > 1) throw new Error("Terdeteksi lebih dari satu wajah. Pastikan hanya Anda di dalam foto.");
      await portalApi.post("/portal/wajah", { photo: canvas.toDataURL("image/jpeg", 0.85), descriptor: faces[0] });
      toast.success("Wajah berhasil didaftarkan");
      await refresh();
    } catch (e) {
      setMsg(e.response ? errMsg(e) : e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <section data-testid="face-register" className="fade-up space-y-5">
      <div className="rounded-2xl border border-primary/20 bg-white p-5">
        <div className="flex items-start gap-3">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-secondary text-primary"><ScanFace className="h-6 w-6" /></div>
          <div>
            <h2 className="font-heading text-lg font-semibold text-gray-900">Daftar Wajah</h2>
            <p className="text-sm text-gray-500">Sebelum check-in pertama, daftarkan wajah Anda. Ambil selfie langsung dari kamera depan.</p>
          </div>
        </div>
      </div>
      {!modelReady && !msg && <p data-testid="face-model-loading" className="flex items-center justify-center text-sm text-gray-500"><Loader2 className="mr-2 h-4 w-4 animate-spin" />Menyiapkan pengenal wajah…</p>}
      {msg && <p data-testid="face-register-error" className="rounded-xl bg-red-50 px-4 py-3 text-sm font-medium text-red-700">{msg}</p>}
      <CameraCapture onCapture={onCapture} busy={busy || !modelReady} busyLabel={modelReady ? "Memeriksa wajah…" : "Menyiapkan…"} label="Ambil Selfie & Daftar" testid="face-register-camera" />
    </section>
  );
}
